package pl.finn.forms.swz


import io.kvision.core.onEvent
import io.kvision.form.*
import io.kvision.form.select.Select
import io.kvision.form.select.selectOption
import io.kvision.form.text.Text
import io.kvision.html.*
import io.kvision.modal.Alert
import io.kvision.modal.Confirm
import io.kvision.panel.SimplePanel
import io.kvision.state.bind
import io.kvision.utils.px
import pl.finn.forms.POLE_WYMAGANE
import pl.finn.forms.common.BlockList
import pl.finn.forms.fk02.DynamicFieldsValidator


class SwzPanel : SimplePanel() {

    private val dynamicFieldsValidator = DynamicFieldsValidator()
//  val rozszerzeniaZalacznikow = setOf(
//    "7z", "avi", "CAdES", "css", "csv", "dgn", "doc",
//    "docx", "dwf", "dwg", "dxf", "geotiff", "gif", "gml", "gz", "gzip", "html",
//    "jp2", "jpeg", "jpg", "m4a", "mp3", "mp4", "mpeg", "mpeg4", "mpg", "odp", "ods",
//    "odt", "ogg", "ogv", "ott", "PAdES", "pdf", "png", "ppt", "pptx", "rng", "rtf",
//    "svg", "tar", "tif", "tiff", "tls", "txt", "wav", "XAdES", "xhtml", "xls",
//    "xlsx", "xml", "XMLenc", "XMLsig", "xps", "xsd", "xsl", "xslt", "zip"
//  ) // Util.rozszerzeniaZalacznikow

    init {
        bind(Model.formularzStore)
        { state ->
            main {
                margin = 15.px
                id = "peupcontent"
                state.bladZapisu?.let {
                    div(it, className = "alert alert-danger") {
                        role = "alert"
                    }
                }
                when (state.widok) {
                    FormularzWidok.EDYCJA, FormularzWidok.NOWY -> {
                        if (state.form != null) {
                            val swzBlockList = BlockList(dynamicFieldsValidator)
                            val swzBlocks = SwzBlocks(dynamicFieldsValidator)

                            val formPanel = formPanel<SwzForm>(
                                type = FormType.HORIZONTAL, horizRatio = FormHorizontalRatio.RATIO_2, className = "mx-2 mx-md-5 mt-3",
                                condensed = true
                            ) {
                                add(createButtonPanel(state, this@formPanel))
                                h1(
                                    "Skarga, wniosek, zapytanie do urzędu", //tytuł
                                    className = "h4 text-center"
                                ) {
                                    tabindex = -1
                                }
                                //place for fields [start]

                                add(
                                    dynamicFieldsValidator.add(
                                        Text(
                                            value = state.form.miejscowoscDokumentu,
                                            label = "Miejscowość"
                                        ).apply {
                                           // placeholder = "Miejscowość"
                                            onEvent {
                                                change = {
                                                    state.form.miejscowoscDokumentu = self.value
                                                }
                                            }
                                            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                            flabel.addCssClass("required-label")
                                        },
                                        { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
                                        POLE_WYMAGANE
                                    )
                                )

                                add(swzBlockList.generateModifiableList(
                                    state.form.informacje,
                                    swzBlocks.blokInformacji,
                                    ::Informacje,
                                    "Treść skargi, wniosku, zapytania do urzędu",
                                    { iter -> "Skarga/Wniosek/Zapytanie $iter" }
                                ))
                                add(
                                    dynamicFieldsValidator.add(
                                        Select(
                                            value = state.form.odpowiedz,
                                            label = "Sposób odpowiedzi"
                                        ).apply {
                                            placeholder = "Wybierz sposób odpowiedzi"
                                            emptyOption = true
                                            onEvent {
                                                change = {
                                                    state.form.odpowiedz = self.value

                                                }
                                            }
                                            for ((key, value) in swzData.listOfTypesOfReturns) {
                                                selectOption(value = key,label = value)
                                                liveSearch = true
                                            }
                                        },
                                        { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
                                        POLE_WYMAGANE
                                    )
                                )
                                add(swzBlockList.generateModifiableList(
                                    state.form.informacjeDodatkowe,
                                    swzBlocks.blokInfoDodatkowe,
                                    ::InformacjeDodatkowe,
                                    "Informacje dodatkowe",
                                    { iter -> "Informacja $iter" }
                                ))
                                add(

                                        Text(
                                            value = state.form.podpis.zUpowaznienia,
                                            label = "Z upoważnienia"
                                        ).apply {
                                            // placeholder = "Tekst wewnątrz"
                                            onEvent {
                                                change = {
                                                    state.form.podpis.zUpowaznienia = self.value
                                                }
                                            }
                                            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)

                                        },

                                )

                                add(

                                        Text(
                                            value = state.form.podpis.imieNazwiskoGrupa.imie,
                                            label = "Imię"
                                        ).apply {
                                            // placeholder = "Tekst wewnątrz"
                                            onEvent {
                                                change = {
                                                    state.form.podpis.imieNazwiskoGrupa.imie = self.value
                                                }
                                            }
                                            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)

                                        },

                                )
                                add(

                                        Text(
                                            value = state.form.podpis.imieNazwiskoGrupa.imieDrugie,
                                            label = "Drugie imię"
                                        ).apply {
                                            // placeholder = "Tekst wewnątrz"
                                            onEvent {
                                                change = {
                                                    state.form.podpis.imieNazwiskoGrupa.imieDrugie = self.value
                                                }
                                            }
                                            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)

                                        },

                                )
                                add(

                                            Text(
                                                value = state.form.podpis.imieNazwiskoGrupa.nazwiskoCzlonPierwszy,
                                                label = "Nazwisko Pierwszy Człon"
                                            ).apply {
                                                // placeholder = "Tekst wewnątrz"
                                                onEvent {
                                                    change = {
                                                        state.form.podpis.imieNazwiskoGrupa.nazwiskoCzlonPierwszy = self.value
                                                    }
                                                }
                                                styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)

                                            },

                                        )
                              add(

                                    Text(
                                        value = state.form.podpis.imieNazwiskoGrupa.nazwiskoCzlonDrugi,
                                        label = "Nazwisko Drugi Człon"
                                    ).apply {
                                        onEvent {
                                            change = {
                                                state.form.podpis.imieNazwiskoGrupa.nazwiskoCzlonDrugi = self.value
                                            }
                                        }
                                        styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                    }
                                )
                                add(

                                        Text(
                                            value = state.form.podpis.imieNazwiskoGrupa.nazwiskoCzlonTrzeci,
                                            label = "Nazwisko Trzeci Człon"
                                        ).apply {
                                            onEvent {
                                                change = {
                                                    state.form.podpis.imieNazwiskoGrupa.nazwiskoCzlonTrzeci = self.value
                                                }
                                            }
                                            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
                                        }
                                    )

                                add(

                                        Text(
                                            value = state.form.podpis.stanowisko,
                                            label = "Stanowisko"
                                        ).apply {
                                            onEvent {
                                                change = {
                                                    state.form.podpis.stanowisko = self.value
                                                }
                                            }
                                            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)

                                        },

                                )
//

                                //place for fields [end]
                            }
                        }
                    }
                    else -> {}
                }
            }

        }

    }

//    fun createAddressElement(adres: Adres): FieldsetPanel {
//        return FieldsetPanel().apply {
//            var polaAdresu = Div().apply {
//                visible = adres.posiadaAdres
//                lateinit var poleMiejscowosci: FormControl
//                lateinit var polePoczty: FormControl
//                lateinit var poleUlicy: FormControl
//                add(
//                    dynamicFieldsValidator.add(
//                        Text(
//                            value = adres.kodPocztowy,
//                            label = "Kod Pocztowy"
//                        ).apply {
//                            onEvent {
//                                change = {
//                                    adres.kodPocztowy = self.value
//                                    pl.finn.forms.swz.Model.onEditPostalCodeRefresh(
//                                        adres.kodPocztowy,
//                                        polePoczty as TomTypeahead,
//                                        poleMiejscowosci as TomTypeahead,
//                                        poleUlicy as TomTypeahead
//                                    )
//                                }
//                            }
//                            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
//                            flabel.addCssClass("required-label")
//                        },
//                        { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible)) },
//                        POLE_WYMAGANE,
//                        "doWiadomosci"
//                    )
//                )
//                polePoczty = dynamicFieldsValidator.add(
//                    TomTypeahead(
//                        value = adres.poczta,
//                        label = "Poczta"
//                    ).apply {
//                        onEvent {
//                            change = {
//                                adres.poczta = self.value
//                            }
//                        }
//                        styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
//                        flabel.addCssClass("required-label")
//                    },
//                    { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible)) },
//                    POLE_WYMAGANE,
//                    "doWiadomosci"
//                )
//                add(polePoczty)
//                poleMiejscowosci = dynamicFieldsValidator.add(
//                    TomTypeahead(
//                        value = adres.miejscowosc,
//                        label = "Miejscowość"
//                    ).apply {
//                        onEvent {
//                            change = {
//                                adres.miejscowosc = self.value
//                            }
//                        }
//                        styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
//                        flabel.addCssClass("required-label")
//                    },
//                    { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible)) },
//                    POLE_WYMAGANE,
//                    "doWiadomosci"
//                )
//                add(poleMiejscowosci)
//                poleUlicy =
//                    TomTypeahead(
//                        value = adres.ulica,
//                        label = "Ulica"
//                    ).apply {
//                        onEvent {
//                            change = {
//                                adres.ulica = self.value
//                            }
//                        }
//                        styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
//                    }
//
//                add(poleUlicy)
//                add(
//                    dynamicFieldsValidator.add(
//                        Text(
//                            value = adres.budynek,
//                            label = "Budynek"
//                        ).apply {
//                            onEvent {
//                                change = {
//                                    adres.budynek = self.value
//                                }
//                            }
//                            styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
//                            flabel.addCssClass("required-label")
//                        },
//                        { elem -> ((!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible)) },
//                        POLE_WYMAGANE,
//                        "doWiadomosci"
//                    )
//                )
//                add(
//                    Text(
//                        value = adres.lokal,
//                        label = "Lokal"
//                    ).apply {
//                        onEvent {
//                            change = {
//                                adres.lokal = self.value
//                            }
//                        }
//                        styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_2)
//                    },
//
//                    )
//            }
//            add(
//                CheckBox(value = adres.posiadaAdres, label = "Adres", rich = true)
//                    .apply {
//                        onEvent {
//                            change = {
//                                adres.posiadaAdres = self.value
//                                if (self.value) {
//                                    polaAdresu.show()
//                                } else {
//                                    polaAdresu.hide()
//                                }
//                            }
//                        }
//                    }
//            )
//            add(polaAdresu)
//        }
//    }

    private fun createButtonPanel(state: Formularz, reference: FormPanel<SwzForm>): Div {
        return (
                Div(className = "form-group my-3") {
                    div(className = "row") {
                        div(className = "col-lg-6") {
                            div(className = "row") {
                                div(className = "col-sm-6 py-2") {
                                    button(
                                        "Zapisz dokument",
                                        "far fa-save fa-3x d-block",
                                        ButtonStyle.SUCCESS, className = "w-100"
                                    ).onClick {
                                        val referenceData = state.form /*getReferenceData(reference, state)*/
                                        val validateResult = null // Dokument zapisze bez walidacji
                                        referenceData?.let { it1 -> Model.zapisz(it1, validateResult) }
                                    }
                                }
                                div(className = "col-sm-6 py-2") {
                                    button("Sprawdź dokument", "fas fa-tasks fa-3x d-block", className = "w-100").onClick {
//                  val isValidatedStatic = reference.validate()
                                        val isValidatedDynamic = dynamicFieldsValidator.validate()
                                        if (/*isValidatedStatic &&*/ isValidatedDynamic) {
                                            Alert.show(
                                                "Sprawdzenie dokumentu",
                                                "Dokument jest poprawny.<br/>Wszystkie pola wypełnione są prawidłowo.",
                                                rich = true
                                            )
                                        } else {
                                            Alert.show(
                                                "Sprawdzenie dokumentu",
                                                "Dokument zawiera niepoprawne dane.<br/>Należy poprawić pola oznaczone na czerwono.",
                                                rich = true
                                            )
                                        }
                                        Model.sprawdz()
                                    }
                                }
                            }
                        }
                        div(className = "col-lg-6") {
                            div(className = "row") {
                                div(className = "col-sm-6 py-2") {
                                    button("Podgląd dokumentu", "fas fa-eye fa-3x d-block", className = "w-100").onClick {
                                        val referenceData = state.form /*getReferenceData(reference, state)*/
                                        referenceData?.let { it1 -> Model.podglad(it1, this) }
                                    }
                                }
                                div(className = "col-sm-6 py-2") {
                                    button(
                                        "Anuluj",
                                        "fas fa-times fa-3x d-block",
                                        ButtonStyle.SECONDARY, className = "w-100"
                                    ).onClick {
                                        Confirm.show(
                                            "Potwierdzenie",
                                            "Czy anulować edycję formularza i powrócić do poprzedniej strony?",
                                            yesTitle = "Tak",
                                            noTitle = "Nie"
                                        ) {
                                            Model.anuluj()
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                )
    }

}
